
import { ascendingSlaCompare, getArrayData } from '../utils';


const initialSettings = {
    success: false,
    appliedOn: '',
    notifyUsers: []
}


const createSmSlaData = (store, smId, values) => {
    return {
        ...store.data,
        [smId]: {
          ...(store.data[smId] || {}),
          ...values
        }
      }
}


export const storeSlaList = (store, payload) => {
    const {data} = payload;
    const sortedData = data ?  data.sort(ascendingSlaCompare) :  [];
    const smId = store.currentSmId;
    const oldSettings = store.data[smId] && store.data[smId].settings
    const newData = createSmSlaData(store, smId, {
      slaList: sortedData,
      onceFetched:true,
      settings: oldSettings || initialSettings
    })
    return {
        ...store,
        data: newData
    }
}


export const createSlaInStore = (store, payload) => {
    const {data} = payload;
    const smId = store.currentSmId;
    const slaList = store.data?.[smId]?.slaList ?? [];
    const newData = createSmSlaData(store, smId, {
        slaList: [...slaList, data],
    })
    return {...store, data: newData};
}

export const updateSlaInStore = (store, payload) => {
    const {data} = payload;
    const {sla_id} = data;
    const smId = store.currentSmId;
    const newList = store.data[smId].slaList.map((sla) => sla.sla_id === sla_id ? data : sla );
    const newData = createSmSlaData(store, smId, {
        slaList: newList,
    })
    return {...store, data: newData};
}

export const toggleSlaInStore = (store, payload) => {
    const {slaId, enabled} = payload;
    if(!slaId){
        return store;
    }
    const smId = store.currentSmId;
    const newList = store.data[smId].slaList.map((sla) => {
        if(sla.sla_id === slaId){
            return {...sla, enabled}
        }
        return sla;
    });
    const newData = createSmSlaData(store, smId, {
        slaList: newList,
    })
    return {...store, data: newData};
}

export const removeOrRevertSla = (store, payload) => {
    const {slaIds} = payload;
    const smId = store.currentSmId;
    const newList = slaIds.map((id) => store.data[smId].slaList.find(sla => sla.sla_id === id));
    const newData = createSmSlaData(store, smId, {
        slaList: newList,
    })
    return {...store, data: newData};
}

export const fetchOrUpdateSlaSettings = (store, payload) => {
    const {apply_on, notify_on_delete} = payload;
    const smId = store.currentSmId;
    const oldSettings = store.data[smId] && store.data[smId].settings
    const settings = {
        ...(oldSettings || {}),
        success:true,
        appliedOn: apply_on,
        notifyUsers: [...getArrayData(notify_on_delete.notify_alias), ...getArrayData(notify_on_delete.notify_users)]
    }
    const newData = createSmSlaData(store, smId, {
        settings,
    })
    return {
        ...store,
        data: newData
    }
}

export const fetchSlaSettingsFailed = (store) => {
    const smId = store.currentSmId;
    const oldSettings = store.data[smId] &&  store.data[smId].settings;
    const newData = createSmSlaData(store, smId, {
        settings: oldSettings ? {...oldSettings, success:false } : initialSettings,
    })

    return {
        ...store,
        data: newData
    }
}